import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { IVolunteerAttendance } from './models';
import { invalidateVolunteerRoster } from './useVolunteerRoster';

export const useAdjustAttendanceHoursMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: IVolunteerAttendance) => void;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({
			attendanceId,
			hours,
			impersonationContext,
		}: {
			attendanceId: string;
			activityId: string;
			hours: number;
			impersonationContext?: Api.IImpersonationContext;
		}) =>
			userSession.webServiceHelper.callAsync<IVolunteerAttendance>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `volunteering/attendance/${attendanceId}/hours`,
				}),
				'PUT',
				{ hours }
			),
		onSuccess: (data, variables) => {
			invalidateVolunteerRoster(variables.activityId);
			onSuccess?.(data);
		},
		onError,
	});
};
